'use es6';

import { List, Record } from 'immutable';
import HubDbRow from './HubDbRow';
import { RequestStatus } from '../constants/base';
const DEFAULTS = {
  rows: List(),
  status: RequestStatus.UNINITIALIZED
};
class HubDbRows extends Record(DEFAULTS) {
  static fromJS(data) {
    return new HubDbRows({
      rows: List(data.objects).map(HubDbRow.fromJS),
      status: RequestStatus.SUCCEEDED
    });
  }
}
export default HubDbRows;